<template>
  <div class="container login-page mt-3">
    <div class="row">
      <div
        class="col-xs-12 col-sm-6 col-md-4 offset-sm-3 offset-md-4 text-center">
        <h3>Add User</h3>
        <p v-if="errorMessage" class="mb-3">{{ errorMessage }}</p>
        <div class="form-group">
          <input
            id="email"
            v-model="userEmail"
            type="email"
            name="email"
            class="form-control"
            placeholder="Email">
        </div>
        <div class="form-group">
          <input
            id="pass"
            v-model="userPass"
            type="password"
            name="pass"
            class="form-control"
            placeholder="Password">
        </div>
        <button class="btn btn-primary login-btn" @click="register()">
          Submit
        </button>
      </div>
    </div>

    <modal-alert
      v-if="showModal"
      :msg="successMessage"
      @close="showModal = false"/>
  </div>
</template>

<script>
import firebase from 'firebase';
import ModalAlert from '../components/ModalAlert.vue';
import EventBus from '../services/eventBus.js';

export default {
	name: 'AddUser',
	components: {
		ModalAlert,
		EventBus,
	},
	data: () => {
		return {
			userEmail: '',
			userPass: '',
			errorMessage: '',
			successMessage: '',
			showModal: false,
		};
	},
	mounted() {
		EventBus.$on('closeAlert', () => {
			this.showModal = false;
			this.redirectHome();
		});
	},
	beforeDestroy() {
		EventBus.$off('closeAlert');
	},
	methods: {
		register: function() {
			const $this = this;
			firebase
				.auth()
				.createUserWithEmailAndPassword(this.userEmail, this.userPass)
				.then((obj) => {
					this.successMessage =
						'Account created for ' + obj.user.email;
					this.showModal = true;
				})
				.catch(function(error) {
					$this.errorMessage = error.message;
				});
		},
		redirectHome: function() {
			this.$router.push('/languages');
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/AddUser.vue